import { render, staticRenderFns } from "./restaurant-image-caption.vue?vue&type=template&id=4a691383&scoped=true&"
import script from "./restaurant-image-caption.vue?vue&type=script&lang=js&"
export * from "./restaurant-image-caption.vue?vue&type=script&lang=js&"
import style0 from "./restaurant-image-caption.vue?vue&type=style&index=0&id=4a691383&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a691383",
  null
  
)

export default component.exports